import { render, staticRenderFns } from "./ConnectedAccountReturnedPage.vue?vue&type=template&id=cf1ca7ac&"
import script from "./ConnectedAccountReturnedPage.vue?vue&type=script&lang=js&"
export * from "./ConnectedAccountReturnedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports